import { FC } from 'react'

import { MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

import { getBudgetContent } from '../utils/planContentUtils'
import CustomizableSection from './ExecutiveSummary/CustomizableSection'

export interface BudgetProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  useMediaPlanWording?: boolean
  section?: MasterCampaignPlanCustomSection | null
}

const Budget: FC<BudgetProps> = ({ campaigns, useMediaPlanWording = false, section }) => {
  const budgetText = getBudgetContent(campaigns, useMediaPlanWording)

  return <CustomizableSection section={section} defaultTitle='Budget' defaultContent={budgetText} defaultShowTitle={true} separator='spacer' />
}

export default Budget
